import styled from "styled-components";

import { colors, radii } from "shared/ui/tokens";

export const Column = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
    flex: none;
`;

export const OrderButton = styled.button`
    width: 44px;
    height: 44px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 0;
    border-radius: ${radii.order};
    cursor: pointer;
    background: rgba(33, 150, 243, 0.08);
    color: ${colors.secondary};

    &:hover:not(:disabled) {
        background: rgba(33, 150, 243, 0.16);
    }

    &:disabled {
        background: rgba(0, 0, 0, 0.04);
        color: rgba(0, 0, 0, 0.26);
        cursor: default;
    }
`;
